import React, { Fragment, useState, useMemo } from 'react';
import styled, { useTheme } from 'styled-components';
import { Tooltip, Slide, makeStyles } from '@material-ui/core';

import { useCourseFilter } from 'Util/Hooks';
import { Flex, Box, Text, ButtonOutlined, SvgIcon, MUIModal, Formik } from 'Components/Base';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
Transition.displayName = 'Transition';

const { RadioInput } = Formik;

const OptionWrapper = styled(Box)`
  overflow: auto;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &&::-webkit-scrollbar {
    width: 0 !important;
    display: none;
  }
`;

const modalStyle = makeStyles({
  paper: (props) =>
    props.isMobile
      ? {
          height: '50vh',
          width: '100vw',
          borderRadius: '20px 20px 0 0',
          paddingTop: '24px',
          position: 'fixed',
          bottom: '0',
          margin: '0',
        }
      : {
          padding: '34px 0px 22px 0px',
          height: '445px',
          width: '375px',
          borderRadius: '20px',
        },
});

const modalContentStyle = makeStyles({
  root: () => ({
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    '&:first-child': {
      paddingTop: 0,
    },
  }),
});

const useToolTipStyles = makeStyles({
  tooltip: ({ colors, space }) => ({
    fontFamily: 'Noto Sans, Noto Sans Thai, sans-serif',
    background: colors.primary,
    color: colors.white,
    padding: `${space[2]}px`,
    margin: `${space[2]}px ${space[0]}px`,
    textAlign: 'center',
    borderRadius: '8px',
    height: '30px',
    width: '117px',
    fontSize: '12px',
  }),
  arrow: ({ colors }) => ({
    color: colors.primary,
  }),
});

const TuneIcon = (props) => (
  <SvgIcon
    icon={SvgIcon.ICON_LIST.TUNE}
    size={16}
    ml={1}
    // style={{ top: '10px', right: '20px', transform: 'none' }}
    {...props}
  />
);

const Option = ({ label, disabled, checked, ...props }) => (
  <Box width={1} py={3} px={6} bg={checked ? 'primaryLighter' : 'white'}>
    <Text>{label}</Text>
  </Box>
);

const CourseFilterWithSlideUp = ({
  dialogMessage,
  expiredCoursesCount,
  selectedFilters,
  onCategoryChange,
  onSortChange,
  onFilterChange,
  filterOptions,
  ...props
}) => {
  const { _breakpoints, colors, space } = useTheme();
  const isMobile = window.innerWidth < _breakpoints[0];
  const tooltipClasses = useToolTipStyles({ colors, space });
  const modalClasses = modalStyle({ isMobile });
  const modalContentClasses = modalContentStyle();
  const [showDialog, setShowDialog] = useState(true);
  const { COURSE_FILTER } = useCourseFilter();
  const { courseFilter, sortFilter } = filterOptions;

  const hasExpiryFilter = useMemo(() => {
    courseFilter.items.some((item) => item.value === COURSE_FILTER.EXPIRED_COURSES);
  }, [courseFilter.items]);

  return (
    <Fragment>
      <MUIModal
        TransitionComponent={Transition}
        onOpenModal={() => setShowDialog(false)}
        innerProps={{ height: '100%', display: 'flex', flex: '1' }}
        classes={modalClasses}
        modalContentProps={{ classes: modalContentClasses }}
        toggleComponent={
          <Tooltip
            title={dialogMessage}
            open={hasExpiryFilter && expiredCoursesCount > 0 && showDialog}
            classes={tooltipClasses}
            placement={'top'}
            arrow
          >
            <ButtonOutlined variant={'small'}>
              <Flex alignItems={'center'} justifyContent={'center'}>
                <Text color={'primary'}>ตัวกรอง</Text>
                <TuneIcon />
              </Flex>
            </ButtonOutlined>
          </Tooltip>
        }
        {...props}
      >
        <OptionWrapper width={1}>
          {courseFilter.items.length > 0 && (
            <RadioInput
              label={courseFilter.label}
              labelProps={{ fontWeight: 'bold', py: 3, px: 6 }}
              value={selectedFilters[0]}
              options={courseFilter.items}
              renderItem={(option) => <Option {...option} />}
              onChange={(event) => onFilterChange(event.target.value, 0)}
              width={1}
            />
          )}
          {sortFilter.items.length > 0 && (
            <RadioInput
              label={sortFilter.label}
              labelProps={{ fontWeight: 'bold', py: 3, px: 6 }}
              value={selectedFilters[1]}
              options={sortFilter.items}
              onChange={(event) => onFilterChange(event.target.value, 1)}
              renderItem={(option) => <Option {...option} />}
              width={1}
            />
          )}
        </OptionWrapper>
      </MUIModal>
    </Fragment>
  );
};

export default CourseFilterWithSlideUp;
